import { createStyles } from 'antd-style'

export const useStyle = createStyles(({ token }) => ({
  userMessage: {
    fontFamily: token.fontFamilyCode,
    display: 'flex',
    flexDirection: 'column',
    padding: token.padding,
    marginBottom: token.margin,
    background: '#F6F8FA',
    borderRadius: '12px',
    maxWidth: '80%',
    width: 'fit-content',
    alignSelf: 'flex-end',
    marginLeft: 'auto',
    willChange: 'transform, opacity',
    transform: 'translateZ(0)',
    backfaceVisibility: 'hidden',
  },

  messageText: {
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
    fontSize: '16px',
    color: '#212329',
  },
}))
